import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import TextFieldDate from '../../UI/TextFieldDate';
import { Grid } from '@mui/material';
import dayjs from 'dayjs';

const useStyles = makeStyles({
    paper: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    },
    closeIcon: {
        marginTop: '20px',
        cursor: 'pointer'
    },
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    },
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 180,
    }
});

export default function CronogramaDataForm({ cronogramaData, setCronogramaData, loadingSave, clickSubmit }) {
    const classes = useStyles();

    const handleDataInicioChange = (dataInicio) => {
        // if (dataInicio)
        //     dataInicio.setHours(0, 0, 0, 0);

        setCronogramaData({
            ...cronogramaData,
            dataInicio: dayjs(dataInicio)
        })
    }

    const handleDataFimChange = (dataFim) => {
        // if (dataFim)
        //     dataFim.setHours(0, 0, 0, 0);

        setCronogramaData({
            ...cronogramaData,
            dataFim: dayjs(dataFim)
        })
    }

    return (
        <Container className={classes.paper} component={Paper}>
            <CloseIcon
                fontSize='small'
                onClick={() => (setCronogramaData(null))} className={classes.closeIcon} />
            <form onSubmit={clickSubmit}>
                <Grid container>
                    <Grid size={12}>
                        <TextFieldDate
                            required
                            label="Data Início"
                            value={cronogramaData && cronogramaData.dataInicio ? cronogramaData.dataInicio : null}
                            onChange={handleDataInicioChange}
                        />
                    </Grid>
                    <Grid size={12}>
                        <TextFieldDate
                            label="Data Fim"
                            value={cronogramaData && cronogramaData.dataFim ? cronogramaData.dataFim : null}
                            onChange={handleDataFimChange}
                        />
                    </Grid>
                    <Grid size={12}>
                        <Button

                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            disabled={loadingSave}
                        >
                            {loadingSave && <CircularProgress className={classes.loading} color="primary" size={20} />}
                            Salvar
                        </Button>
                    </Grid>

                </Grid>

            </form>
        </Container>
    );
}